import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useContext, useEffect, useRef, useState, } from 'react';
import TimeAgoMessage from './TimeAgoMessage.js';
import ToastContext from './ToastContext.js';
import ToastEnum from './ToastEnum.js';
const BasicToastBody = ({ id, type, title, message, timestamp, duration, distanceFormatLocale, className, ...divProps }) => {
    const { removeToast } = useContext(ToastContext);
    const doesTimeout = duration > 0;
    const doesTimeoutShortly = doesTimeout && duration <= 60000;
    const [expiring, setExpiring] = useState(false);
    const expiringTimeout = useRef(undefined);
    useEffect(() => {
        if (doesTimeout) {
            expiringTimeout.current = setTimeout(() => {
                setExpiring(true);
                removeToast(id);
            }, duration);
            return () => {
                if (expiringTimeout.current) {
                    clearTimeout(expiringTimeout.current);
                }
            };
        }
        return () => undefined;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsxs("div", { className: clsx(expiring && 'toast__fadeout', className), ...divProps, children: [_jsxs("div", { className: clsx('toast-header text-white', type === 'error' ? 'bg-gradient-danger' : 'bg-gradient-success'), children: [_jsx("strong", { className: "mr-auto", children: title }), timestamp && !doesTimeoutShortly && (_jsx(TimeAgoMessage, { timestampUnix: timestamp, locale: distanceFormatLocale })), _jsx("button", { type: "button", className: "close unstyled-button ml-2 px-1 fs-4 lh-1", "aria-label": "Close", onClick: () => {
                            clearTimeout(expiringTimeout.current);
                            expiringTimeout.current = undefined;
                            setExpiring(true);
                            removeToast(id);
                        }, children: _jsx("span", { "aria-hidden": "true", children: "\u00D7" }) })] }), _jsx("div", { className: clsx('toast-body text-white', type === ToastEnum.Error ? 'bg-gradient-danger' : 'bg-gradient-success'), children: message }), doesTimeoutShortly && (_jsx("div", { className: "toast__progress", style: { animationDuration: `${duration}ms` } }))] }));
};
export default BasicToastBody;
//# sourceMappingURL=BasicToastBody.js.map